import { Directive, Input, OnChanges } from "@angular/core";
import { AbstractControl, NG_VALIDATORS, Validator } from "@angular/forms";
import { RutHelper } from "src/app/helpers/rut.helper";

export function validarRut(rut: string): boolean {
	return RutHelper.validate(rut);
}

@Directive({
	selector: "[appVerificaRut]",
	providers: [
		{
			provide: NG_VALIDATORS,
			useExisting: VerificacionRutValidatorDirective,
			multi: true,
		},
	],
})
export class VerificacionRutValidatorDirective implements Validator, OnChanges {
	@Input() appVerificaRut: boolean | string = true;
	private onValidatorChange: () => void = () => {};
	registerOnValidatorChange(fn: () => void): void { this.onValidatorChange = fn; }
	ngOnChanges(): void { this.onValidatorChange(); }

	validate(control: AbstractControl): { [key: string]: any } | null {
		const rut = control.value;
		if (this.appVerificaRut === false || !rut) {
			return null;
		}
		const isValid = validarRut(rut);
		return isValid ? null : { rutNoValido: true };
	}
}

export function VerificacionRutValidator(control: AbstractControl): { [key: string]: any } | null {
	if (control.value == null || control.value === "") return null;
	let rutValido = validarRut(control.value);
	if (!rutValido && control.value != "") {
		return { VerificacionRutValidator: true };
	}
	return null;
}
